export const USER_TYPE_INSURED_TYPE = "Insured";
export const USER_TYPE_UNINSURED_TYPE = "Uninsured";
